export default __webpack_public_path__ + "static/media/Now-Regular.75a37ab5.otf";